"use client";

import { Button } from "@mui/material";
import { GridRowId } from "@mui/x-data-grid";
import { useUnassignDialog } from "../Providers/UnassignDialogContext";

export default function CancelButton() {
  const { closeUnassignDialog, setUserRowSelectionModel } = useUnassignDialog();

  const handleClose = () => {
    setUserRowSelectionModel({
      ids: new Set<GridRowId>([]),
      type: "include",
    });
    closeUnassignDialog();
  };

  return (
    <Button onClick={handleClose} type="button" size="medium" variant="text">
      Cancel
    </Button>
  );
}
